import { render, staticRenderFns } from "./MultiSelectMenuItem.vue?vue&type=template&id=6361188c&scoped=true"
import script from "./MultiSelectMenuItem.vue?vue&type=script&lang=js"
export * from "./MultiSelectMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectMenuItem.vue?vue&type=style&index=0&id=6361188c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361188c",
  null
  
)

export default component.exports